<template>
    <a-drawer width="50%" title="合同详情" placement="right" :maskClosable="false" :visible="VipContractInfoDrawerVisible" @close="onClose">
        <a-descriptions title="甲方信息">
            <a-descriptions-item label="会员期限">
                {{ info.termOfValidity }}
            </a-descriptions-item>
            <a-descriptions-item label="提交时间">
                {{ moment(info.addTime) }}
            </a-descriptions-item>
            <a-descriptions-item label="审核状态">
                {{ info.contractSignState == 0 ? "未审核" : info.contractSignState == 1 ? "已通过" : info.contractSignState == 2 ? "已拒绝" : "" }}
            </a-descriptions-item>
            <a-descriptions-item label="甲方盖章照片" :span="3">
                <img @click="preview(info.fileUrl)" class="img" :src="resourcesHost + info.fileUrl" />
            </a-descriptions-item>
        </a-descriptions>
        <a-descriptions title="乙方信息">
            <a-descriptions-item label="乙方盖章照片" :span="3">
                <span v-if="info.contractSignState == 0">审核中</span>
                <span v-if="info.contractSignState == 2">已拒绝</span>
                <img v-if="info.contractSignState == 1" @click="preview(info.contractSignUrl)" class="img" :src="resourcesHost + info.contractSignUrl" />
            </a-descriptions-item>
            <a-descriptions-item label="审核说明" :span="3">
                {{ info.contractSignExplain || "" }}
            </a-descriptions-item>
        </a-descriptions>
        <Vviewer ref="viewer"></Vviewer>
    </a-drawer>
</template>
<script>
import Vviewer from "../../../components/Vviewer.vue";
export default {
    components: { Vviewer },
    props: ["VipContractInfoDrawerVisible", "closeVipContractInfoDrawer", "flowId"],
    data() {
        return {
            info: {},
            resourcesHost: process.env.VUE_APP_RESOURCES_HOST,
        };
    },
    watch: {
        VipContractInfoDrawerVisible(data) {
            if (data) {
                this.getInfo();
                this.resourcesHost = process.env.VUE_APP_RESOURCES_HOST;
            }
        },
    },
    methods: {
        moment(time) {
            return this.$moment(time).format("YYYY-MM-DD HH:mm:ss");
        },
        preview(url) {
            this.$refs.viewer.show([
                {
                    thumbnail: process.env.VUE_APP_RESOURCES_HOST + url,
                    source: process.env.VUE_APP_RESOURCES_HOST + url,
                },
            ]);
        },
        getInfo() {
            const _this = this;
            this.$http
                .get("/contractsign/query?flowId=" + this.flowId)
                .then((res) => {
                    if (res.rescode == 200) {
                        this.info = res.data;
                    } else {
                        _this.$Notification["error"]({
                            message: "请求失败！",
                            description: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                    _this.$Notification["error"]({
                        message: "请求失败！",
                        description: res.msg,
                    });
                });
        },
        onClose() {
            this.closeVipContractInfoDrawer();
        },
    },
};
</script>
<style lang="less" scoped>
.img {
    width: 100px;
    height: 50px;
    margin-right: 8px;
    cursor: pointer;
}
.ant-divider {
    margin: 0 8px;
}
</style>
